<div [ngClass]="user_theme">
    <div class="app-container">
        <div class="nav-app">
            <tabs (onUserThemeChange)="themeChangeHandler($event)" [userTheme]="user_theme"></tabs>
            <button class="version-footer" (click)="tabsComponent.openDialog('changelog')">{{ 'DECOLONIAL.IST Navigator v' | tr }}{{ navVersion }}</button>
        </div>
    </div>
</div>
